import { useUrlGenerator } from '@folklore/routes';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import Summary from './Summary';

import styles from '../../styles/summaries/brand-summary.module.css';

type BrandSummaryProps = {
    slug?: string | null;
    label?: string | null;
    image?: Record<string, unknown> | null;
    metadata?: {
        sponsors?: Array<Record<string, unknown>> | null;
    } | null;
    className?: string | null;
    imageClassName?: string | null;
    pictureClassName?: string | null;
} & Record<string, unknown>;

function BrandSummary({
    slug = null,
    label = null,
    image = null,
    metadata = null,
    className = null,
    imageClassName = null,
    pictureClassName = null,
    ...props
}: BrandSummaryProps) {
    const { sponsors = null } = metadata || {};
    const [sponsor = null] = sponsors || [];
    const url = useUrlGenerator();

    return (
        <Summary
            link={
                slug !== null
                    ? url('home', {
                          slug,
                      })
                    : null
            }
            title={label}
            sponsor={sponsor}
            image={image}
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
            imageClassName={classNames([
                styles.image,
                {
                    [imageClassName]: imageClassName !== null,
                },
            ])}
            pictureClassName={classNames([
                styles.picture,
                {
                    [pictureClassName]: pictureClassName !== null,
                },
            ])}
            buttonLabel={<FormattedMessage defaultMessage="Voir plus" description="Button label" />}
            {...props}
        />
    );
}

export default BrandSummary;
